import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useToast, useFetch, useModal, useGrid, useAuth, useResource, usePage } from "@/comn/hooks";
import { URLS, APIS, SF_DDLN_XTNS_DTL, SG_UPD_BLL_DTL_LIST } from "./services/OsciBllService"; // 서비스
import { APIS_COMN, SF_COMN_BLL_INFO, SF_COMN_BLL_SRCH } from "@/tz/go/egaz/osci/colt/comn/OsciColtComnService"; // 공통 서비스
import { colEnvs, colUtils } from "@/tz/go/egaz/osci/colt/comn";
import { SF_APRV_RQST } from "@/comn/comn/aprv/service/AprvService";
import { OgaAprvRqst } from "@/comn/comn/aprv/OgaAprvRqst";

/*
 * Deadline Extension Detail
 * !== 데드라인 연장 상세 ==!
 */
export const OSCI0401005Q = () => {
    const resource = useResource({
        defaultSchema: [],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003", "auth_osci0021"],
    }); // Page Unique identifier !== 화면 고유 식별자 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const { bllMgmtId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!
    const { aprvYn } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!

    // 버튼 처리
    const [isVisibleBtn, setIsVisibleBtn] = useState(false);

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0056" },
            { area: "comnCd", comnCd: "OSC0057" },
            { area: "comnCd", comnCd: "OSC0058" },
            { area: "comnCd", comnCd: "OSC0065" },
            { area: "comnCd", comnCd: "OSC0067" },
            { area: "comnCd", comnCd: "OSC0072" },
            { area: "comnCd", comnCd: "OSC0018" },
            { area: "comnCd", comnCd: "OSC0023" },
            { area: "comnCd", comnCd: "OSC0096" },
            { area: "coCd" },
            { area: "bnkCd" },
        ],
    });

    const [vsbTansad, setVsbTansad] = useState(false);
    const [vsbBll, setVsbBll] = useState(false);
    const [vsbDdlnXtns, setVsbDdlnXtns] = useState(false);
    const [vsdDtls, setVsdDtls] = useState(false);

    const [bllDtlList, setBllDtlList] = useState(comnUtils.getGridData([]));
    const [ddlnXtnsDgr, setDdlnXtnsDgr] = useState<string | undefined>();
    const [ddlnXtnsBllMgmtId, setDdlnXtnsBllMgmtId] = useState<string | undefined>();

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */

    const form = {
        // Bill Search !== 고지 검색 ==!
        bllSrch: useForm({
            defaultSchema: SF_COMN_BLL_SRCH,
            defaultValues: {},
        }),
        // Bill General !== 고지 일반 ==!
        bllGnrl: useForm({
            defaultSchema: SF_COMN_BLL_INFO,
            defaultValues: {},
        }),
        // Deadline Extension General !== 데드라인 연장 일반 ==!
        ddlnXtnsGnrl: useForm({
            defaultSchema: SF_DDLN_XTNS_DTL,
            defaultValues: {},
        }),
        aprvRqstForm: useForm({
            defaultSchema: SF_APRV_RQST,
            defaultValues: {
                ptlTpCd: "O", // 포털 구분 코드 (I: 내부, O: 외부)
                bsopClsfCd: "COL", // 업무 구분 코드
                scrnDocCd: "scrn_colt0013", // 문서 ID
                aprvReffId: "/" + bllMgmtId + "/Y", // 결재 요청 문서 Key 값
                aprvAfPrcssCfgnId: "cfgn_col0023", // 결재완료 후처리 ID (결재후처리설정 테이블에 등록된 후처리ID)
                rtrnAfPrcssCfgnId: "cfgn_col0024", // 반려 후처리 ID (결재후처리설정 테이블에 등록된 후처리ID)
                prevStageRtrnUseYn: "Y", // 이전단계 반려처리가 필요한 경우에만 'Y'로 넘겨 줄 것 (결재처리 시 이전단계반려 라디오버튼을 보여줌)
                itsfAprvYn: "N", // 업무팀 자체 결재처리 시 'Y'로 넘겨 줄 것 (결재처리탭 비활성화)
            },
        }),

        SF_DDLN_XTNS_DTL,
    };

    const today = new Date();

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Bill Detail List !== 고지 상세 목록 ==!
        bllDtlList: useGrid({
            defaultSchema: SG_UPD_BLL_DTL_LIST,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */

    const readyFunc = {
        readyBtn: (data: any) => {
            // const lgnAuthLst = auth.get("authList");
            // const lgnUsrId = auth.get("usrId");
            // const aprvPrcssStatCd = data?.aprvPrcssStatCd;
            // const rgsrOfcrId = data?.xtnsRgsrOfcrId;
            //
            // if (lgnAuthLst.includes("auth_coli0013") || lgnAuthLst.includes("auth_osci0019")) {
            //     if (rgsrOfcrId == lgnUsrId && aprvPrcssStatCd != "A01" && aprvPrcssStatCd != "A03") {
            //         setIsVisibleBtn(true);
            //     }
            // }

            setIsVisibleBtn(false);

            if (data?.ddlnXtnsStatCd) {
                if (data.ddlnXtnsStatCd === "R") {
                    setIsVisibleBtn(true);
                }
            }
        },
        readyBll: (data: any) => {
            form.bllGnrl.setValues({
                ...data.bllInfo.content,
            });

            form.bllSrch.setValues({
                ...data.bllInfo.content,
            });

            if (data.bllInfo.content != null) {
                setVsbBll(true);
            }
            if (data.bllInfo.content.reffKeyTpCd == "T") {
                setVsbTansad(true);
            }

            if (data.bllInfo.content.reffKeyTpCd == null || data.bllInfo.content.reffKeyTpCd == "") {
                form.bllGnrl.setValue("reffKey", "");
            } else {
                if (data.bllInfo.content.reffKeyTpCd == "T" || data.bllInfo.content.reffKeyTpCd == "B") {
                    form.bllGnrl.setValue(
                        "reffKey",
                        data.bllInfo.content.reffKeyNo1 +
                            "-" +
                            data.bllInfo.content.reffKeyNo2 +
                            "-" +
                            data.bllInfo.content.reffKeyNo3,
                    );
                } else if (data.bllInfo.content.reffKeyTpCd == "A") {
                    form.bllGnrl.setValue("reffKey", data.bllInfo.content.reffKeyNo1);
                } else {
                    if (data.bllInfo.content.reffKeyNo4 == null || data.bllInfo.content.reffKeyNo4 == "") {
                        form.bllGnrl.setValue(
                            "reffKey",
                            data.bllInfo.content.reffKeyNo1 +
                                "-" +
                                data.bllInfo.content.reffKeyNo2 +
                                "-" +
                                data.bllInfo.content.reffKeyNo3,
                        );
                    } else {
                        form.bllGnrl.setValue(
                            "reffKey",
                            data.bllInfo.content.reffKeyNo1 +
                                "-" +
                                data.bllInfo.content.reffKeyNo2 +
                                "-" +
                                data.bllInfo.content.reffKeyNo3 +
                                "-" +
                                data.bllInfo.content.reffKeyNo4,
                        );
                    }
                }
            }

            if (data.bllInfo.content.dcltNm != null && data.bllInfo.content.dcltNm != "") {
                form.bllGnrl.setValue(
                    "dcltTinNm",
                    colUtils.setMask(data.bllInfo.content.dcltTin, "tin") + " (" + data.bllInfo.content.dcltNm + ")",
                );
            } else {
                form.bllGnrl.setValue("dcltTinNm", colUtils.setMask(data.bllInfo.content.dcltTin, "tin"));
            }

            if (data.bllInfo.content.exppnImppnNm != null && data.bllInfo.content.exppnImppnNm != "") {
                form.bllGnrl.setValue(
                    "exppnImppnTinNm",
                    colUtils.setMask(data.bllInfo.content.exppnImppnTin, "tin") +
                        " (" +
                        data.bllInfo.content.exppnImppnNm +
                        ")",
                );
            } else {
                form.bllGnrl.setValue("exppnImppnTinNm", colUtils.setMask(data.bllInfo.content.exppnImppnTin, "tin"));
            }

            if (data.bllInfo.content.pyerTpCd == "T") {
                if (data.bllInfo.content.pyerNm != null && data.bllInfo.content.pyerNm != "") {
                    form.bllGnrl.setValue(
                        "pyerMgmtNoNm",
                        colUtils.setMask(data.bllInfo.content.pyerMgmtNo, "tin") +
                            " (" +
                            data.bllInfo.content.pyerNm +
                            ")",
                    );
                } else {
                    form.bllGnrl.setValue("pyerMgmtNoNm", colUtils.setMask(data.bllInfo.content.pyerMgmtNo, "tin"));
                }
            } else {
                if (data.bllInfo.content.pyerMgmtNo == null || data.bllInfo.content.pyerMgmtNo == "") {
                    form.bllGnrl.setValue("pyerMgmtNoNm", data.bllInfo.content.pyerNm);
                } else {
                    if (data.bllInfo.content.pyerNm != null && data.bllInfo.content.pyerNm != "") {
                        form.bllGnrl.setValue(
                            "pyerMgmtNoNm",
                            colUtils.setMask(data.bllInfo.content.pyerMgmtNo, "tin") +
                                " (" +
                                data.bllInfo.content.pyerNm +
                                ")",
                        );
                    } else {
                        form.bllGnrl.setValue("pyerMgmtNoNm", colUtils.setMask(data.bllInfo.content.pyerMgmtNo, "tin"));
                    }
                }
            }

            if (data.bllInfo.content.bllRgsrId && data.bllInfo.content.bllRgsrNm) {
                form.bllGnrl.setValue(
                    "bllRgsrIdNm",
                    data.bllInfo.content.bllRgsrId + "/" + data.bllInfo.content.bllRgsrNm,
                );
            } else if (data.bllInfo.content.bllRgsrId) {
                form.bllGnrl.setValue("bllRgsrIdNm", data.bllInfo.content.bllRgsrId);
            } else if (data.bllInfo.content.bllRgsrNm) {
                form.bllGnrl.setValue("bllRgsrIdNm", data.bllInfo.content.bllRgsrNm);
            }

            if (data.bllInfo.content.bllTpCd && data.bllInfo.content.bllTpCd === "G") setVsdDtls(true);
            if (data.bllInfo.content.bllDtls) {
                setBllDtlList(comnUtils.getGridData(data.bllInfo.content.bllDtls));
            }
        },
    };

    const fetch = {
        // Get Deadline Extension !== 데드라인 연장 조회 ==!
        getDdlnXtns: useFetch({
            api: (data) =>
                APIS.getDdlnXtns(
                    form.bllSrch.getValue("bllTpCd") +
                        "-" +
                        form.bllSrch.getValue("bllSysmCd") +
                        "-" +
                        form.bllSrch.getValue("bllYy") +
                        "-" +
                        form.bllSrch.getValue("bllSrno") +
                        "-" +
                        form.bllSrch.getValue("bllDgr"),
                ),
            onSuccess: (data) => {
                if (data.ddlnXtnsDtl.content.bllDgr != null) {
                    setVsbDdlnXtns(true);
                }

                form.ddlnXtnsGnrl.setValues({
                    ...data.ddlnXtnsDtl.content,
                });

                setDdlnXtnsDgr(data.ddlnXtnsDtl.content.ddlnXtnsDgr);
                setDdlnXtnsBllMgmtId(data.ddlnXtnsDtl.content.bllMgmtId);

                form.bllSrch.setEditable(false);

                readyFunc.readyBtn(data.ddlnXtnsDtl.content);
            },
            onError: (error) => {},
            showToast: true,
        }),
        // Delete Deadline Extension !== 데드라인 연장 삭제 (해당 회차만) ==!
        deleteDdlnXtns: useFetch({
            api: (bllMgmtIdArg, ddlnXtnsDgrArg) => APIS.deleteDdlnXtns(bllMgmtIdArg, ddlnXtnsDgrArg),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00006",
                    onConfirm: () => {
                        navigate(URLS.osci0401004q);
                    },
                    onCancel: () => {
                        navigate(URLS.osci0401004q);
                    },
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00015",
                });
            },
        }),
        // Get Bill !== 고지서 조회 ==!
        getBll: useFetch({
            api: (data) => APIS_COMN.getBll(bllMgmtId),
            enabled: !!bllMgmtId,
            onSuccess: (data) => {
                readyFunc.readyBll(data);
                fetch.getDdlnXtns.fetch();
            },
            onError: (error) => {},
            showToast: true,
        }),
        // Get Bill Search !== 고지서 검색 조회 ==!
        getBllSrch: useFetch({
            api: (data) => APIS_COMN.getBllDtl(form.bllSrch.getValues()),
            onSuccess: (data) => {
                if (data.bllInfo.content != null) {
                    readyFunc.readyBll(data);
                    fetch.getDdlnXtns.fetch();
                } else {
                    toast.showToast({ type: "warning", content: "msg.osc.00050" });
                }
            },
            onError: (error) => {
                toast.showToast({ type: "warning", content: "msg.osc.00003" });
            },
            showToast: true,
        }),
        // Deadline Extension Approval Request After !== 데드라인 연장 승인 요청 후 처리 ==!
        ddlnXtnsAprvRqstAf: useFetch({
            api: (data) => APIS.ddlnXtnsAprvRqstAf(data),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006",
                    onConfirm: () => {
                        navigate(URLS.osci0401004q);
                    },
                    onCancel: () => {
                        navigate(URLS.osci0401004q);
                    },
                });
            },
            onError: (data) => {},
            showToast: true,
        }),
        updtBill: useFetch({
            api: (data) => {
                return APIS.updtBll(data);
            },
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006", //Processed successfully.
                    onClose: () => {
                        fetch.getDdlnXtns.fetch();
                    },
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00015", //An error occurred during processing.
                });
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get Deadline Extension Search !== 데드라인 연장 검색 조회 ==!
        getDdlnXtnsSrch: () => {
            form.bllSrch.handleSubmit((data) => {
                // Validation Check !== 밸리데이션 체크 ==!
                fetch.getBllSrch.fetch();
            })();
        },
        // Click Apprvoal Request Button !== 결재 요청 버튼 클릭 ==!
        onAprvRqstBtnClick: () => {
            modal.openModal({
                // url: "/comn/comn/ppup/aprvRqstPpup",
                // params: {
                //     bsopClsfCd: "COL", //업무시스템 구분
                //     scrnDocCd: "scrn_colt0013", //화면문서코드테이블에 등록된 화면문서ID
                //     aprvReffId: "/" + bllNo + "/Y", //결재문서 조회를 위한 결재참고ID
                //     aprvAfPrcssCfgnId: "cfgn_col0023", // 결재 승인 후 처리 설정 테이블에 등록된 후처리ID
                //     rtrnAfPrcssCfgnId: "cfgn_col0024", // 결재 반려 후 처리 설정 테이블에 등록된 후처리ID
                // },
                // size: "md",
                // draggable: true,
                // callback: (data) => {
                //     // !== 결재완료 후 해당 callback 함수에 결재번호를 리턴해줌  ==!
                //     console.log("Check Data 결재아이디 >>>>> ", data.aprvId);
                //     modal.closeModal();

                //     const param = { ...form.bllSrch.getValues(), aprvId: data.aprvId };

                //     // // 결재상신 후 처리
                //     fetch.ddlnXtnsAprvRqstAf.fetch(param);
                // },
                content: (
                    <OgaAprvRqst
                        paramData={{
                            bsopClsfCd: "OSC", // 업무시스템 구분
                            scrnDocCd: "scrn_colt0013", // 화면문서코드테이블에 등록된 화면문서ID
                        }}
                        callbackFn={(aprvData: any) => {
                            if (aprvData) {
                                form.aprvRqstForm.setValues({
                                    aprvId: aprvData.aprvId,
                                    aprvRqstTtleNm: aprvData.aprvRqstTtleNm,
                                    aprvRqstCn: aprvData.aprvRqstCn,
                                    usrDmnId: aprvData.usrDmnId,
                                    aprvPrcssPathMgmtId: aprvData.aprvPrcssPathMgmtId,
                                });

                                const param = {
                                    ...form.bllSrch.getValues(),
                                    aprvRqstDto: form.aprvRqstForm.getValues(),
                                };
                                console.log("callbackFn data", param);
                                fetch.ddlnXtnsAprvRqstAf.fetch(param);
                            }
                            modal.closeModal("OgaAprvRqst");
                        }}
                    />
                ),
                size: "md",
                draggable: true,
                close: false,
                id: "OgaAprvRqst",
            });
        },
        updtBill: form.bllGnrl.handleSubmit(
            () => {
                const data = { ...form.bllGnrl.getValues(), ...form.ddlnXtnsGnrl.getValues() };
                modal.openModal({
                    content: "msg.osc.00180", //Do you want to execute?
                    onConfirm: () => {
                        fetch.updtBill.fetch(data);
                    },
                });
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.osc.00003" });
            },
        ),
        // Delete Deadline Extension !== 데드라인 연장 삭제 (현재 조회된 회차만) ==!
        deleteDdlnXtns: () => {
            modal.openModal({
                content: "msg.osc.00095",
                onConfirm: () => {
                    fetch.deleteDdlnXtns.fetch(ddlnXtnsBllMgmtId, ddlnXtnsDgr);
                },
            });
        },
    };

    const render = {
        grid_bllDtlList: {
            head: {},
            cell: {
                bllMgmtId: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <span>
                            {`${rowValues.bllTpCd}-${rowValues.bllSysmCd}-${rowValues.bllYy}-${rowValues.bllSrno}-${rowValues.bllDgr}`}
                        </span>
                    );
                },
            },
            edit: {},
        },
    };

    useEffect(() => {
        form.bllSrch.setEditable(true);
        form.bllGnrl.setEditable(false);
        form.ddlnXtnsGnrl.setEditable(false);
    }, []);

    return (
        <Page>
            {aprvYn != "Y" && (
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.bllSrch.schema.bllNo} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Label {...form.bllSrch.schema.bllMgmtId}></Group.Label>
                                <Group.Field size={4}>
                                    <Group.Control
                                        {...form.bllSrch.schema.bllTpCd}
                                        onPaste={(e: any) => {
                                            e.preventDefault();
                                            const data = e.clipboardData.getData("Text").replaceAll("-", "");

                                            form.bllSrch.setValue("bllTpCd", data.substring(0, 1));
                                            form.bllSrch.setValue("bllSysmCd", data.substring(1, 5));
                                            form.bllSrch.setValue("bllYy", data.substring(5, 7));
                                            form.bllSrch.setValue("bllSrno", data.substring(7, 14));
                                            form.bllSrch.setValue("bllDgr", data.substring(14, 15));
                                        }}
                                    />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.bllSrch.schema.bllSysmCd} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.bllSrch.schema.bllYy} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.bllSrch.schema.bllSrno} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.bllSrch.schema.bllDgr} />
                                </Group.Field>
                            </Group.Row>
                        </Group.Section>

                        {/* <Layout direction="row">
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getDdlnXtnsSrch();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout> */}
                    </Group.Body>
                </Group>
            )}

            {vsbTansad && (
                <Group>
                    <Group.Body>
                        <Group.Title title={"L_TANSAD_GNRL"} titleSize={2}></Group.Title>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.tansadNo} />
                                <Group.Control {...form.bllGnrl.schema.tansadDt} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.regm} />
                                <Group.Control {...form.bllGnrl.schema.csclPlnCd} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.exppnImppnTinNm} />
                                <Group.Control {...form.bllGnrl.schema.dcltTinNm} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.dclrPrcssSttsCd} />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}
            {vsbBll && (
                <>
                    <Group>
                        <Group.Body>
                            <Group.Title title={"L_BLL_GNRL"} titleSize={2}></Group.Title>
                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.bllNo} />
                                    <Group.Control {...form.bllGnrl.schema.bllDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.ctrlNo} />
                                    <Group.Control {...form.bllGnrl.schema.zmpDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.bllTpCdSec} />
                                    <Group.Control {...form.bllGnrl.schema.bllStatCd} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.pyerMgmtNoNm} />
                                    <Group.Control {...form.bllGnrl.schema.bllRgsrIdNm} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.reffKeyTpCd} />
                                    <Group.Control {...form.bllGnrl.schema.reffKey} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.feeAmt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.payDdlnDt} />
                                    <Group.Control {...form.bllGnrl.schema.lastDdlnXtnsDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.xtnsDt} />
                                    <Group.Control {...form.bllGnrl.schema.lastDdlnXtnsRsn} />
                                </Group.Row>
                            </Group.Section>
                        </Group.Body>
                    </Group>
                    {vsdDtls && (
                        <Group>
                            <Group.Body>
                                {" "}
                                <Layout direction="row">
                                    <Layout.Left>
                                        <Group.Title title={"T_BLL_DTL_1"} titleSize={2}></Group.Title>
                                    </Layout.Left>
                                </Layout>
                                <Grid {...grid.bllDtlList.grid} data={bllDtlList} render={render.grid_bllDtlList} />
                            </Group.Body>
                        </Group>
                    )}
                </>
            )}
            {vsbDdlnXtns && (
                <Group>
                    <Group.Body>
                        <Group.Title title={"L_DDLN_XTNS"} titleSize={2}></Group.Title>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.ddlnXtnsGnrl.schema.ddlnXtnsDt} />
                                <Group.Control {...form.ddlnXtnsGnrl.schema.ddlnXtnsStatCd} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.ddlnXtnsGnrl.schema.ddlnXtnsRsn} />
                                <Group.Control {...form.ddlnXtnsGnrl.schema.xtnsRgsrOfcrNm} />
                                {/* <Group.Control {...form.ddlnXtnsGnrl.schema.aprvPrcssStatCd} /> */}
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}
            {aprvYn != "Y" && (
                <Layout direction="row">
                    <Layout.Left>
                        <Button
                            role="list"
                            onClick={() => {
                                navigate(URLS.osci0401004q);
                            }}
                        ></Button>
                    </Layout.Left>
                    {isVisibleBtn && (
                        <Layout.Right>
                            <Button
                                onClick={() => {
                                    handler.updtBill();
                                }}
                            >
                                {t("B_ZMP_SEND")}
                            </Button>
                            <Button
                                onClick={() => {
                                    navigate(
                                        `${URLS.osci0401006s}/updt/${form.bllGnrl.getValues().bllTpCd}-${
                                            form.bllGnrl.getValues().bllSysmCd
                                        }-${form.bllGnrl.getValues().bllYy}-${form.bllGnrl.getValues().bllSrno}-${
                                            form.bllGnrl.getValues().bllDgr
                                        }`,
                                    );
                                }}
                            >
                                {t("B_UPDT")}
                            </Button>
                            <Button
                                role="delete"
                                onClick={() => {
                                    handler.deleteDdlnXtns();
                                }}
                            ></Button>

                            {/* <Button variant="primary" onClick={handler.onAprvRqstBtnClick}>
                                {t("B_APRV_RQST")}
                            </Button> */}
                        </Layout.Right>
                    )}
                </Layout>
            )}
        </Page>
    );
};
